import controller from './contracts.controller';

export default {
  bindings: {
    onConfirm: '&',
    onDistantSales: '&',
    onPreInfo: '&',
    showPreInfo: '<',
    disableChecked : '<'
  },
  controller,
  template: require('./contracts.html')
};



// WEBPACK FOOTER //
// src/app/buy/contracts/contracts.component.ts